import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getPosts } from 'features/blog/posts/actions';
import Grid from '@material-ui/core/Grid';
import BlogCard from 'views/Blog/elements/BlogCard';
import FullHeightGrid from 'components/FullHeightGrid';

const BlogList = React.memo(({ count, posts, getPosts }) => {
  useEffect(() => {
    getPosts({ limit: count || 3 });
  }, [getPosts, count]);

  return (
    <Grid container justify="space-between" spacing={40}>
      {posts.map((post, idx) => (
        <FullHeightGrid item xs={12} md={4} key={idx}>
          <BlogCard post={post} />
        </FullHeightGrid>
      ))}
    </Grid>
  );
});

export default connect(
  state => ({
    posts: state.blogPosts.posts
  }),
  {
    getPosts
  }
)(BlogList);
